'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';

class ErrorTooltip extends React.Component {
  render() {
    return (
      <div className="tooltip-error">
        <FormattedMessage
          className="error-tooltip-content"
          id={this.props.error}
        />
      </div>
    );
  }
}

export default ErrorTooltip;
